import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-cancellation-reasons',
  imports: [RouterModule],
  templateUrl: './cancellation-reasons.html',
  styleUrl: './cancellation-reasons.scss',
})
export class CancellationReasons {
  
}
